export default "__VITE_ASSET__DrqANe5m__"